import { ApiClient, Client } from "../../entities/NSwagGenerated"
import Tracker from "@openreplay/tracker"

export abstract class appAuth {
	public static async loginToAppWithOktaToken(token: string, cypressTest: boolean = false): Promise<string> {
		const apiClient = new ApiClient(import.meta.env.VITE_API_URL.toString())
		return apiClient.login(token).then(
			(res) => {
				if (!cypressTest) {
				}
				localStorage.setItem("PersonSessionData", JSON.stringify(res))
				localStorage.setItem("token", token)
				return "ok"
			},
			(err) => {
				return err.toString()
			}
		)
	}
}
